import React, {PureComponent} from 'react';

import LandingFreelance from './LandingFreelanceUniverse.jsx';

import header from './images/header-generic-hr.png';

const metaDescription = "Découvrez nos missions en management de transition et interim management pour consultant " +
  "indépendant dans le secteur des ressources humaines";

export default class LandingFreelanceHr extends PureComponent {
  render() {
    return (
      <LandingFreelance
        headerImg={header.src}
        metaDescription={metaDescription}
        metaTitle="Missions pour professionnels des Ressources Humaines"
        sectorText="des ressources humaines"
        universeCode="hr"
      />
    )
  }
}
